/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const getUserProfile = async () =>
  fetch('/api/user/profile', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const setUserProfile = async (profile: any) =>
  fetch('/api/user/profile', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(profile),
  }).then((e) => e.json());

export const isTokenValid = async () =>
  fetch('/api/alive', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
